import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import PageBase from '../../../widgets/PageBase/PageBase';
import CustomerRow from '../../../widgets/MRS/CustomerRow';
import List from 'material-ui/List';
import Divider from 'material-ui/Divider';
import DataTablePagination from '../../../widgets/data-table/DataTable/DataTablePagination/DataTablePagination';
import { RaisedButton, TextField } from 'material-ui';
import './CustomerSelect.css';

const CustomerSelectPage = (props) => {
  const [search, setSearch] = React.useState('');

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    props.onCustomerSearch(search);
  };

  return (
    <div>
      <PageBase navigation={['MRS']} includeInactiveBranches>
        <>
          <div className="customer-select-top-container">
            <form
              className="customer-select-search-form"
              onSubmit={handleSubmit}
            >
              <div className="customer-select-seach-box">
                <TextField
                  hintText={props.intl.formatMessage({
                    id: 'mrs_search_customers_hint'
                  })}
                  value={search}
                  onChange={handleChange}
                />
              </div>
              <div>
                <RaisedButton
                  label={props.intl.formatMessage({
                    id: 'mrs_search_button_text'
                  })}
                  primary
                  type="submit"
                />
              </div>
            </form>
            <div>
              <DataTablePagination
                page={props.paginatedCustomers}
                onChangePage={props.onChangePage}
                onChangeRowsPerPage={props.onChangeRowsPerPage}
              />
            </div>
          </div>
          <List>
            {props.paginatedCustomers.content?.map((customer, index, array) => {
              const lastElement = index == array.length - 1;
              return (
                <React.Fragment key={customer.customerId}>
                  <CustomerRow
                    customer={customer}
                    handleClick={() => props.handleCustomerSelect(customer)}
                    disabled={props.shouldDisableCustomer(customer)}
                  />
                  {!lastElement ? <Divider /> : null}
                </React.Fragment>
              );
            })}
          </List>
          <div className="customer-select-bottom-container">
            <DataTablePagination
              page={props.paginatedCustomers}
              onChangePage={props.onChangePage}
              onChangeRowsPerPage={props.onChangeRowsPerPage}
            />
          </div>
        </>
      </PageBase>
    </div>
  );
};

export default injectIntl(CustomerSelectPage);
